import React, {useEffect, useState} from "react";
import {ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, IconButton,} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {MdAdd, MdArrowDropDown, MdRemove} from "react-icons/md";
import Search from "./Search";
import BadgeFilter from "./BadgeFilter";
import styled from "styled-components";
import {Category, IAttributes} from "../../reducers/project";
import {useDispatch, useSelector} from "react-redux";
import {
  getEditable,
  getSelectedAttributes,
  isModelSelected,
  getCustomAttributes,
  getGlassCount,
} from "../../reducers/project/selectors";
import selectAttr from "../../actions/project/selectAttr";
import AlertDialog from "../../containers/Dialog/Dialog";
import Scrollbars from "react-custom-scrollbars";
import content from "../../content";
import {useDesktop} from "../Responsive";
import question from '../../assets/icons/question.png'
import {ProjectActions} from "../../reducers/project/actionsNames";
import {cloneDeep} from "lodash/fp";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: "14px",
    fontWeight: 600,
    color: "black",
  },
  expansionHeader: {
    maxHeight: "40px",
    backgroundColor: "#F5F4F4",
    border: "1px solid #EAE5E5",
  },
  expansionHeaderExpanded: {
    minHeight: "40px !important",
  },
  expansionBody: {
    border: "1px solid #EAE5E5",
    backgroundColor: "white",
  },
}));

const FilterContainer = styled.div<{ more?: boolean }>`
  display: flex;
  flex-wrap: ${(props) => props.more ? 'wrap' : 'unset'};
  overflow: hidden;
  margin: 12px 0px 8px -5px;
`;

function AttributesExpansion({
                               attr,
                               name,
                               setOpenInfo,
                               multi,
                               custom,
                               toggleNext,
                               expanded,
                               expandedName,
                               toggleExpand,
                             }: IAttributesExpansion) {
  const [tagFilter, setTagFilter] = useState<string[]>([]);
  const [search, setSearch] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [attrib, setAttr] = useState();
  const [more, setMore] = useState(false);
  const editable = useSelector(getEditable);
  const selectedAttr = useSelector(getSelectedAttributes);
  const customAttr = useSelector(getCustomAttributes);


  const isModel = useSelector(isModelSelected);


  const dispatch = useDispatch();
  const classes = useStyles();
  const desktop = useDesktop()

  const addTagFilter = (tag: string) => setTagFilter([...tagFilter, tag]);
  const removeTagFilter = (tag: string) =>
    setTagFilter(tagFilter.filter((t) => t !== tag));
  const toggleTagFilter = (tag: string) =>
    !!tagFilter.find((t) => tag === t)
      ? removeTagFilter(tag)
      : addTagFilter(tag);
  const select = (attr: IAttributes) => () => {
    if (attr.category == Category.Model) {
      dispatch({type: 'deselect all attributes'})
      fetch(process.env.REACT_APP_API_URL + `/attribute?model=${attr.slug.split('_')[0]}`,).then(data => data.json()).then(data => {

        const attrClone = cloneDeep(
          data.attributes.map((attr) => ({
            ...attr,
            dependency: Array.isArray(attr.dependency) ? {} : attr.dependency,
          })))

        dispatch({
          type: ProjectActions.SetAttributes,
          attr: attrClone,
          selected: [attr, ...attrClone.filter(a => {
            if (a.category in attr.default) {
              if (a.category === 'color') {
                return a.slug.includes(attr.default[a.category].replace(attr.slug + '_', '')) && 'variant' in a.dependency && a.dependency['variant'][0].slug === attr.default['variant']
              }
              return attr.default[a.category] === a.slug
            }
          })].filter((v,i,a)=>a.findIndex(t=>(t.category === v.category))===i)
        });



      })
    } else {
      !attr.disabled && dispatch(selectAttr(attr, custom));
    }
    if (toggleNext) {
      toggleNext()
    }
  };

  const tags = [
    ...(new Set<any>(
      attr.reduce<any>((a, b) => a + b.tags.trim().toLowerCase() + ", ", "").split(", ")
    ) as any),
  ].filter(Boolean).filter(t => t !== 'tagi');


  const filteredAttr = attr.filter(
    (a) =>
      (tagFilter.length === 0) ||
      !!tagFilter.find((t) => a.tags.toLowerCase().includes(t.trim().toLowerCase()))
  ).filter(a => {
    return search === "" || (search
      ? a.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()) ||
      a.tags.toLowerCase().includes(search.toLowerCase())
      : false)
  });

  const onSearchChange = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setSearch(e.currentTarget.value);

  useEffect(() => {
    setSearch("");
    setTagFilter([]);
  }, [name]);

  const openDialog = (a: any) => () => {
    setAttr(a);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const onExpand = () => {
    toggleExpand(expandedName);
  };

  return (
    <>
      <AlertDialog
        open={open}
        handleClose={handleClose}
        action={select(attrib)}
        title={content.getValue('notification_header_model')}
        label={content.getValue('notification_info_model')}
      />
      <ExpansionPanel
          style={{
            margin:'0 0 16px 0'
          }}
        defaultExpanded={!multi}
        expanded={expanded}
        onChange={onExpand}
      >
        <ExpansionPanelSummary
          classes={{
            root: classes.expansionHeader,
            expanded: classes.expansionHeaderExpanded,
          }}
          expandIcon={<MdArrowDropDown/>}
        >
          <div
            style={{
              fontSize: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {name}
          </div>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails classes={{root: classes.expansionBody}}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              overflow: "hidden",
            }}
          >
            <Search
              value={search}
              placeholder={content.getValue("input_search")}
              onChange={onSearchChange}
            />
            <FilterContainer more={more}>
              {tags.map((t) => (
                <BadgeFilter
                  selected={!!tagFilter.find((tag) => tag === t)}
                  onClick={() => toggleTagFilter(t)}
                >
                  {t}
                </BadgeFilter>
              ))}
              {tags.length > 5 && <div style={more ? {} : {
                backgroundColor: 'white',
                position: 'absolute',
                right: '17px',
                paddingLeft: '2px',
                display: 'flex'
              }}>
                {!more && <>...</>}
                  <BadgeFilter
                      selected={more}
                      onClick={() => setMore(!more)}>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center'
                      }}>{content.getValue(more ? 'show_less' : 'show_more')}{' '}{more ? <MdRemove/> : <MdAdd/>}</div>
                  </BadgeFilter>
              </div>}
            </FilterContainer>
            <Scrollbars
              autoHeight={true}
              autoHeightMax={desktop ? "calc(60vh - 200px)" : "50vh"}
              autoHeightMin={"40px"}
            >
              <div style={{
                display: 'grid',
                gridTemplateColumns: desktop? "1fr 1fr 1fr 1fr":"1fr 1fr",
                gridGap: '10px'
              }}>
                {filteredAttr
                  .sort(function (a, b) {
                    if (a.category === Category.Size) {
                      return Number(a.name.split(' ')[0]) - Number(b.name.split(' ')[0])
                    }
                    return ("" + a.name).localeCompare(b.name);
                  })
                  .map((a) => {
                    const labelId = `checkbox-list-label-${a.slug}`;

                    return a.disabled || a.name.toLowerCase().includes('zawiasy') ? (
                      <></>
                    ) : (
                      <Attribute custom={custom} selectedAttr={custom ? customAttr : selectedAttr} editable={editable}
                                 isModal={isModel} select={select} openDialog={openDialog} a={a} key={labelId}
                                 setOpenInfo={setOpenInfo}/>
                    );
                  })}
              </div>
            </Scrollbars>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </>
  );
}

const Price = styled.div<{ desktop?: boolean }>`
  color: #c41230;
  font-size: 14px;
  margin-bottom: 25px;
  text-align: center;
  ${(props => props.desktop ? '' : 'line-height: 1')};
`;

const NameLabel = styled.div`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    width: 90%;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 40px;
    min-height: 28px;
    text-align: center;
    line-height: 14px;
`

function Attribute({custom = false, setOpenInfo, selectedAttr, a, editable, select, openDialog, isModal}: any) {

  const desktop = useDesktop()
  const glassCount = useSelector(getGlassCount)

  const stylesHandle: any = (a?.category === Category.Handle || a?.category === Category.HandleColor || a?.category === Category.Signboard)? {
    objectPosition: '-13px 2px',
    transform: 'scale(8)',
    pointerEvents: 'none'
  }:{}

  return <div
    onClick={
      editable
        ? a.category === Category.Model && isModal
        ? openDialog(a)
        : select(a)
        : undefined
    }
    style={{
      width: '100%',
      height: '160px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: Object.values(selectedAttr).includes(custom ? a : a.id) ? '1px solid #C41230' : '1px solid #EAE5E5',
      boxSizing: 'border-box',
      opacity: (a.disabled || !editable) ? 0.7 : 1,
      overflow:'hidden'
    }}>
    {setOpenInfo && !!a.description && <IconButton onClick={(e) => {
      e.preventDefault()
      e.stopPropagation()
      if (setOpenInfo) {
        setOpenInfo(a)
      }
    }} edge="end" aria-label="comments" style={{position: 'absolute', marginLeft: "-50px"}}>
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="12" cy="12" r="12" fill="#EBEBEB"/>
            <path
                d="M10.8213 13.841C10.8213 13.3903 10.921 13.0177 11.1203 12.723C11.3283 12.4283 11.6273 12.1033 12.0173 11.748C12.3033 11.488 12.5113 11.2713 12.6413 11.098C12.78 10.916 12.8493 10.7123 12.8493 10.487C12.8493 10.1663 12.7193 9.91499 12.4593 9.73299C12.208 9.54232 11.87 9.44699 11.4453 9.44699C11.038 9.44699 10.674 9.53365 10.3533 9.70699C10.0413 9.87165 9.77697 10.1057 9.5603 10.409L7.9873 9.48599C8.3513 8.93132 8.84097 8.50232 9.4563 8.19899C10.0803 7.89565 10.817 7.74399 11.6663 7.74399C12.663 7.74399 13.4603 7.95632 14.0583 8.38099C14.665 8.80565 14.9683 9.39499 14.9683 10.149C14.9683 10.5043 14.9076 10.8163 14.7863 11.085C14.6736 11.3537 14.5306 11.5833 14.3573 11.774C14.1926 11.956 13.976 12.1683 13.7073 12.411C13.3866 12.697 13.1526 12.9397 13.0053 13.139C12.858 13.3297 12.7843 13.5637 12.7843 13.841H10.8213ZM11.8093 17.104C11.454 17.104 11.155 16.9913 10.9123 16.766C10.6783 16.532 10.5613 16.2503 10.5613 15.921C10.5613 15.5917 10.6783 15.3187 10.9123 15.102C11.1463 14.8767 11.4453 14.764 11.8093 14.764C12.1733 14.764 12.4723 14.8767 12.7063 15.102C12.9403 15.3187 13.0573 15.5917 13.0573 15.921C13.0573 16.2503 12.936 16.532 12.6933 16.766C12.4593 16.9913 12.1646 17.104 11.8093 17.104Z"
                fill="#919090"
            />
        </svg>
    </IconButton>}
    <img
      height={(a?.category === Category.Size || a?.category === Category.Side)? '100px' : "85px"}
      width={"auto"}
      style={(a?.category === Category.Size || a?.category === Category.Side)? {marginTop: '0', marginBottom: '0', ...stylesHandle}:{marginTop: mapsimg(a).includes('$')? '7px':'15px', marginBottom: '5px', ...stylesHandle}}
      src={imgRelative(mapsimg(a))}
    />
    <NameLabel style={{marginTop: a?.price && a.price !== "0" ? '0px' : '15px'}}>{a.name}</NameLabel>
    {a?.price && a.price !== "0" && <Price desktop={desktop}>+{mapGlassPrice(a, glassCount)} {content.getValue("currency")}</Price>}
  </div>
}

export function mapGlassPrice(a, glassCount) {
    if(a?.category === 'glass' && glassCount) {
      return (Number(a?.price) * glassCount).toFixed(2)
    }

    return a?.price
}

export function imgRelative(img) {
  if (img && img.includes('$')) return img.replace('$', '')
  return img ? process.env.REACT_APP_URL + img : question
}


export function mapsimg(a) {
  if (!a) return a?.simg
  if (a.category === Category.Size) {
    switch (a.name) {
      case '60 cm':
        return '$/static/img/ico_60.jpg'
      case '70 cm':
        return '$/static/img/ico_70.jpg'
      case '80 cm':
        return '$/static/img/ico_80.jpg'
      case '90 cm':
        return '$/static/img/ico_90.jpg'
      case '100 cm':
        return '$/static/img/ico_100.jpg'
    }
  }
  if (a.category === Category.Side) {
    switch (a.name) {
      case 'LEWA':
        return '$/static/img/ico_drzwi_lewe.jpg'
      case 'PRAWA':
        return '$/static/img/ico_drzwi_prawe.jpg'
    }
  }

  if (a.category === Category.JambSize) {
    return '$/static/img/ico_zakres_oscieznicy.jpg'
  }

  if (a.category === Category.Adds) {
    if (a.name.toLowerCase().includes('belka dolna')) {
      return '$/static/img/ico_belka_dolna.jpg'
    }
    if (a.name.toLowerCase().includes('bulaj')) {
      return '$/static/img/ico_bulaj.jpg'
    }
    if (a.name.toLowerCase().includes('krata')) {
      return '$/static/img/ico_kratka.jpg'
    }
    if (a.name.toLowerCase().includes('płyta pełna')) {
      return '$/static/img/ico_plyta_pelna.jpg'
    }
    if (a.name.toLowerCase().includes('podcięcie')) {
      return '$/static/img/ico_podciecie.jpg'
    }
    if (a.name.includes('Samozamykacz')) {
      return '$/static/img/ico_samozamykacz.jpg'
    }
    if (a.name.toLowerCase().includes('uszczelka opadająca')) {
      return '$/static/img/ico_uszczelka.jpg'
    }
    if (a.name.toLowerCase().includes('tuleje tworzywowe')) {
      return '$/static/img/ico_tuleje_metalowe.jpg'
    }
    if (a.name.toLowerCase().includes('tuleje metalowe')) {
      return '$/static/img/ico_tulejetworzywo.jpg'
    }
  }

  return a.simg
}


export interface IAttributesExpansion {
  name: string;
  attr: IAttributes[];
  setOpenInfo?: (a: IAttributes) => void;
  multi: boolean;
  custom?: boolean
  expanded: boolean;
  toggleExpand: (name: string) => void;
  toggleNext?: () => void;
  expandedName: any;
}

export default AttributesExpansion;
